import get from "lodash-es/get";

export const getSuggests = (data) => {
  return get(data, "suggestions", {});
};
